export const LARGE_SCREEN_SIZE = 600;
export const AXIOS_TIMEOUT = 60000;

// Roles live in @/utils/roles, which mirrors the backend hierarchy. Re-exported here so
// the existing `@/utils/const` imports keep working against the one source of truth.
export { ADMIN_ROLES, SUPER_ADMIN_ROLES, USER_ROLES } from '@/utils/roles';

export const LOCAL_STORAGE_KEY = 'local';
export const SERVER_ERR_MSG = 'Server Error!';

export const DEFAULT_ERROR_MSG = 'Error! Something went wrong.';
export const TOAST_GLOBAL_CONFIG = { position: 'top-right', dismissible: true };

export const STORAGE_URL = 'https://abol-hr-storage.fra1.digitaloceanspaces.com'

export const ORGANIZATION_LOGO_DIR = 'documents/organization_logos'
export const FOLDER_FILE_DIR = 'documents/folder_files'
export const PROJECT_TRANSACTION_RECEIPT_DIR = 'documents/project_transaction_receipts'
export const PROJECT_FILE_DIR = 'documents/project_files'
export const INVOICES_DIR = 'documents/invoices'
export const PROFILE_PICTURES_DIR = 'documents/profile_pictures'
export const JOB_APPLICATION_FILES_DIR = 'documents/job_application_files'
export const HELP_CENTER_IMAGES_DIR = 'documents/help_center_imgs'
export const INTERNAL_CHAT_FILES_DIR = 'documents/internal_chat_files'
/** Chat attachments go straight from the browser to storage, so the API's body limit does not apply. */
export const CHAT_MAX_FILE_BYTES = 1024 * 1024 * 1024

export const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

export const DATE_NUMBER_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};

export const MONTH_YEAR_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long'
};

export const DATETIME_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const DAYS_OF_THE_WEEK = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

export const DAYS_ABBREV = [
  "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"
];

export const DAYS_OF_THE_WEEK_AMHARIC = ["እሑድ", "ሰኞ", "ማክሰኞ", "ረቡዕ", "ሐሙስ", "ዓርብ", "ቅዳሜ"];

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export const MONTHS_ETHIOPIAN = [
  "Meskerem",
  "Tikimt",
  "Hidar",
  "Tahesas",
  "Tir",
  "Yekatit",
  "Megabit",
  "Miyazia",
  "Ginbot",
  "Sene",
  "Hamle",
  "Nehase",
  "Pagumen",
]

export const MONTHS_ETHIOPIAN_AMHARIC = [
  "መስከረም",
  "ጥቅምት",
  "ኅዳር",
  "ታኅሣሥ",
  "ጥር",
  "የካቲት",
  "መጋቢት",
  "ሚያዝያ",
  "ግንቦት",
  "ሰኔ",
  "ሐምሌ",
  "ነሐሴ",
  "ጳጉሜን",
];

export const MONTHS_ETHIOPIAN_ABBREV = [
  "Mes", "Tik", "Hid", "Tah", "Tir", "Yek", "Meg", "Miy", "Gin", "Sen", "Ham", "Neh", "Pag"
]

export const MONTHS_ABBREV = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
];

export const YEARS: Array<number> = [
  1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969,
  1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979,
  1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989,
  1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999,
  2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009,
  2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019,
  2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030
]

export const CALENDAR_NUMBER_ICONS: Array<string> = [
  'fa-1',
  'fa-2',
  'fa-3',
  'fa-4',
  'fa-5',
  'fa-6',
  'fa-7',
  'fa-8',
  'fa-9',
  'fa-0'
]


export const ATTENDANCE_VIEW_CALENDAR = 'ATTENDANCE_VIEW_CALENDAR'
export const ATTENDANCE_VIEW_EMPLOYEES = 'ATTENDANCE_VIEW_EMPLOYEES'
export const ATTENDANCE_VIEW_LOGS = 'ATTENDANCE_VIEW_LOGS'

export const OVERTIME_VIEW_LOGS = 'OVERTIME_VIEW_LOGS'
export const OVERTIME_VIEW_TYPES = 'OVERTIME_VIEW_TYPES'